import { NolaApiInitializer } from "@/initializer";
import { API } from "aws-amplify";
import {
  CopyFromGuestResultInput,
  CopyFromGuestResultOutput,
  GetMyResultResponse,
} from "../models/writerTypeIndicator";

const API_NAME = "WriterTypeIndicatorAPI";

interface IWriterTypeIndicatorClient {
  copyFromGuestResult: (
    headers: { [key: string]: any },
    payload: CopyFromGuestResultInput
  ) => Promise<CopyFromGuestResultOutput>;

  getMyResult: (headers: { [key: string]: any }) => Promise<GetMyResultResponse>;
}

export class WriterTypeIndicatorClient implements IWriterTypeIndicatorClient {
  async copyFromGuestResult(
    headers: { [key: string]: any },
    payload: CopyFromGuestResultInput
  ): Promise<CopyFromGuestResultOutput> {
    NolaApiInitializer.init();
    return await API.post(API_NAME, "/copy-from-guest-result", { headers, body: payload });
  }

  async getMyResult(headers: { [key: string]: any }): Promise<GetMyResultResponse> {
    NolaApiInitializer.init();
    return await API.get(API_NAME, "/my-result", { headers });
  }
}
